import { render, staticRenderFns } from "./commonTableEditor.vue?vue&type=template&id=5740cfeb"
import script from "./commonTableEditor.vue?vue&type=script&lang=js"
export * from "./commonTableEditor.vue?vue&type=script&lang=js"
import style0 from "./commonTableEditor.vue?vue&type=style&index=0&id=5740cfeb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports